import { Box, Button, List } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { SidebarItem } from 'src/components/SidebarItem'
import { projectAdminSidebarItems } from './project-admin-sidebar-items'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSidebarCtx } from 'src/hooks/context-hooks'

const ProjectAdminSidebar = () => {
  const { t: translate } = useTranslation('projects')
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { collapsibleSidebarOpen } = useSidebarCtx()

  return (
    <Box width={'100%'} sx={{ paddingTop: collapsibleSidebarOpen ? '0px' : '90px' }}>
      <Box display={collapsibleSidebarOpen ? 'block' : 'none'} pt={2} className="p-1 px-1 py-1">
        <Button
          variant="contained"
          color="primary"
          className="w-full"
          sx={{
            fontSize: {
              xs: '12px',
              sm: '12px',
              lg: '18px',
            },
            textTransform: 'none',
            fontWeight: 'bold',
          }}
        >
          {translate('system-project-admin')}
        </Button>
      </Box>

      <List style={{ width: collapsibleSidebarOpen ? '100%' : '72px' }} className="!px-1 !py-1 p-1">
        {projectAdminSidebarItems.map(item => (
          <SidebarItem
            key={item.name}
            active={
              pathname != null &&
              (pathname.split('/').slice(-1)[0] === item.pathname || pathname.split('/')[2] === item.pathname)
            }
            textVisibility={collapsibleSidebarOpen}
            title={translate(item.name)}
            Icon={item.icon}
            onClick={() => navigate(item.path)}
          />
        ))}
      </List>
    </Box>
  )
}

export default ProjectAdminSidebar
